<!--  -->
<template>
  <v-layout class="flex-column white pt-3 pb-6">
    <div
      class="flex-y-center flex-justify-between pb-2 px-4"
      style="border-bottom: 1px solid #eee"
    >
      <div class="flex-y-center">
        <v-btn
          dark
          small
          color="#00bea9"
          depressed
          min-width="32"
          height="30"
          width="100"
          class="mr-2"
          style="padding: 0 8px"
          @click="addShow"
        >
          <v-icon size="16">mdi-plus</v-icon>新增公司
        </v-btn>
        <exportBtn
          :url="$api.exportCompanyList"
          :parmas="{ ...search.data }"
          title="导出"
        />
      </div>
      <div class="flex-y-center">
        <div class="flex-y-center mr-1" style="width: 200px">
          <form-item
            v-model="search.data.companyName"
            class="mr-0"
            placeholder="公司名称"
            type="text"
            allow-close
            @onEnter="getList()"
          />
        </div>
        <v-btn
          dark
          small
          color="primary"
          class="mr-1"
          depressed
          height="30"
          min-width="34"
          style="padding: 0"
          @click="getList()"
        >
          <v-icon size="18">mdi-magnify</v-icon>
        </v-btn>
        <!-- <v-btn depressed color="primary">搜索</v-btn> -->
      </div>
    </div>
    <div class="">
      <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="search.pageSize"
        class="pb-5 max-width pa-4 header-grey"
        hide-default-footer
        :loading="listLoading"
        item-key="id"
        disable-sort
        no-data-text="暂无查询数据"
      >
        <!--
        <template v-slot:item.rowIndex="{ index }">
          {{ index + 1 + search.pageSize * (search.pageNo - 1) }}
        </template> -->
        <template v-slot:item.active="{ item }">
          <div class="flex-y-center">
            <v-icon
              color="primary"
              size="18"
              title="编辑"
              class="mr-1"
              @click="showEdit(item)"
            >mdi-square-edit-outline</v-icon>
            <v-icon
              color="error"
              size="20"
              title="删除"
              class="mr-1"
              @click="handleDelete(item)"
            >mdi-delete-outline</v-icon>
          </div>
        </template>
      </v-data-table>
      <div class="mt-2 pr-2 mb-5 max-width flex-justify-end">
        <pagination
          v-model="search.pageNo"
          :size="search.pageSize"
          :total="total"
          @input="initList"
          @changePageSize="changePageSize"
        />
      </div>
    </div>
    <!-- 新增 编辑 公司 -->
    <ReDialog :value.sync="showDialog" :title="title" @ok="handleSubmit">
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>序号：
        </div>
        <form-item
          v-model="formData.companySeq"
          class="mr-0"
          placeholder="请输入序号"
          required
          type="text"
          @input="handleInputSort"
        />
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>公司名称：
        </div>
        <form-item
          v-model="formData.companyName"
          class="mr-0"
          placeholder="请输入公司名称"
          required
          type="text"
        />
      </div>
    </ReDialog>
  </v-layout>
</template>

<script>
import ReDialog from '@/components/reDialog/index.vue';
export default {
  name: 'CompanyList',
  components: {
    ReDialog,
  },
  data() {
    return {
      search: {
        pageSize: 10,
        pageNo: 1,
        data: {},
      },
      listLoading: false,
      list: [],
      total: 0,
      headers: [
        { text: '序号', value: 'companySeq', width: '50', sortable: false },
        { text: '公司名称', value: 'companyName' },
        { text: '最后修改时间', value: 'updateTime', width: '200' },
        { text: '操作', value: 'active', width: '100', sortable: false },
      ],
      showDialog: false,
      title: '新增公司',
      formData: {},
    };
  },
  created() {
    this.initList();
  },
  methods: {
    initList() {
      this.listLoading = true;
      this.$http
        .get(this.$api.getCompanyList, {
          data: {
            ...this.search.data,
            pageSize: this.search.pageSize,
            pageNo: this.search.pageNo,
          },
        })
        .then((res) => {
          this.list = res.result.records;
          this.total = res.result.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    getList() {
      this.search.pageNo = 1;
      this.initList();
    },
    changePageSize(size) {
      this.search.pageSize = size;
      this.getList();
    },
    addShow() {
      this.showDialog = true;
      this.title = '新增公司';
      this.formData = {};
    },
    showEdit(item) {
      this.showDialog = true;
      this.title = '编辑公司';
      this.formData = { ...item };
    },
    handleInputSort(e) {
      let num = '';
      if (e === '') {
        this.formData.companySeq = '';
        return;
      }
      num = e.toString().replace(/\D/g, '');
      if (num < 0) {
        num = 0;
      }
      this.formData.companySeq = num;
    },
    handleSubmit() {
      let api = this.$api.addCompany;
      let method = 'post';
      if (this.formData.id) {
        api = this.$api.updateCompany;
        method = 'put';
      }
      this.$http[method](api, { data: { ...this.formData } }).then((res) => {
        this.getList();
        this.showDialog = false;
      });
    },
    handleDelete(item) {
      this.$confirm({ text: `是否删除${item.companyName}公司？` }).then(
        (vm) => {
          vm.loading = true;
          this.$http
            .delete(this.$api.deleteCompany, { data: { id: item.id } })
            .then((res) => {
              vm.show = false;
              this.$message.success(res.message);
              this.getList();
            })
            .finally(() => {
              vm.loading = false;
            });
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &__label {
    width: 120px;
    flex-shrink: 0;
    text-align: right;
  }
}
</style>
